export enum IncidentStatus {
	Open = "Open",
	Closed = "Closed",
	SignedOff = "SignedOff",
}
